import styled from 'styled-components';
import { gte } from '@lendi-ui/breakpoint';
import { Button } from '@lendi-ui/button';
import getColour from '@lendi-ui/commons/colours';
import { mt } from '@lendi-ui/spacing';
import { Body } from '@lendi-ui/typography';

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > button {
    ${mt('md')}
  }
`;

export const AddButton = styled(Button)`
  display: block;
  margin: 0 auto;
  ${mt('md')}
  ${gte('md')`
    width: calc(2 / 3 * 100%);
  `}
`;
export const ClickableText = styled(Body)`
  ${mt('nil')};
  color: ${() => getColour('interaction', 'main')};
  cursor: pointer;
`;

export const Disclaimer = styled(Body)<{ align?: 'left' | 'right' | 'center' }>`
  ${mt('md')};
  text-align: ${(props: any) => props.align ?? 'center'};
`;
